import React, { Fragment, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import RoomSingleSection from '../../components/RoomSingleSection'
import { toast } from 'react-toastify';
import service from '../../services/service';
import LoadingOverlay from '../../components/loading/loading';

const RoomSinglePage = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        const getHotelDetails = async () => {
            try {
                setLoading(true);
                const hotelDetail = await service.view(`hotels/${id}`);
                if (hotelDetail && !hotelDetail.success) {
                    toast.error(hotelDetail.message);
                    return;
                }
                setData(hotelDetail.hotel);
            } catch (error) {
                toast.error(error.message);
            } finally {
                setLoading(false);
            }
        };

        getHotelDetails();
    }, [id]); // Only include 'id' in the dependency array

    return (
        <Fragment>
            <Navbar />
            {loading && <LoadingOverlay />}
            {data &&
                <>
                    <PageTitle pageTitle={data.name} pagesub={data.name} />
                    <RoomSingleSection data={data} />
                </>
            }
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default RoomSinglePage;
